import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

interface AdSlideshowProps {
  slideImages: string[];
}

function AdSlideshow({ slideImages }: AdSlideshowProps) {
  return (
    <div>
      <Carousel>
        {slideImages.map((i, index) => (
          <div key={index}>
            <img alt="1" src={i} />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default AdSlideshow;
